import "./index.scss"; // Assurez-vous que le fichier CSS est bien lié
import React, { useEffect, useState } from "react";
import reali1 from "../../assets/r1.png";
import reali12 from "../../assets/r12.png";
import reali13 from "../../assets/r13.png";
import reali14 from "../../assets/r14.png";
import reali15 from "../../assets/r15.png";
import reali16 from "../../assets/r16.png";
import reali17 from "../../assets/r17.png";
import reali18 from "../../assets/r18.png";
import reali19 from "../../assets/r19.png";
import reali112 from "../../assets/r112.png";
import reali113 from "../../assets/r113.png";
import reali114 from "../../assets/r114.png";
import reali115 from "../../assets/r115.png";
import video1 from "../../assets/video1.mp4";
import video2 from "../../assets/video2.mp4";
import video3 from "../../assets/video3.mp4";
import video4 from "../../assets/video4.mp4";
import reali2 from "../../assets/r2.jpg";
import reali22 from "../../assets/reali22.jpg";
import reali23 from "../../assets/reali23.jpg";
import reali3 from "../../assets/r3.jpg";
import reali32 from "../../assets/rea32.jpg";

import { showErrorToaster } from "../toaster/error";
import { useNavigate, useParams } from "react-router-dom";
import rightArrow from "../../assets/btn-next.png";
import leftArrow from "../../assets/btn-suiv.png";
import RealisationService from "../../services/realisation/realisation.service";
const realisationService = new RealisationService();

const Programs = () => {
  const navigate = useNavigate();
  const [realisations, setRealisation] = useState([]);
  const { id } = useParams();
  const [activeIndexes, setActiveIndexes] = useState([]);
  const imageListe = [
    [
      reali1,
      reali12,
      reali13,
      reali14,
      reali15,
      video2,
      reali16,
      reali17,
      reali18,
      reali19,
      reali112,
      video3,
      reali113,
      reali114,
      reali115,
      video1,

      video4,
    ],
    [reali2, reali32],
    [reali3, reali22, reali23],

    ,
  ]; // Tableau des images

  const loadData = async () => {
    try {
      const res = await realisationService?.getAllActiveRealisation();
      setRealisation(res?.data);
      setActiveIndexes(new Array(res?.data.length).fill(0));
    } catch (error) {
      const errorMessage =
        error.response?.data?.message || "Une erreur est survenue.";
      showErrorToaster(errorMessage);
    }
  };

  useEffect(() => {
    if (id) {
      const element = document.getElementById(`list-item-${id}`);
      if (element) {
        element.scrollIntoView({ behavior: "smooth", block: "center" });
      }
    }
  }, [id]);

  useEffect(() => {
    loadData();
  }, []);
  const handlePrevImage = (currentGroupIndex) => {
    setActiveIndexes((prevIndexes) => {
      const newIndexes = [...prevIndexes];
      newIndexes[currentGroupIndex] =
        (newIndexes[currentGroupIndex] -
          1 +
          imageListe[currentGroupIndex].length) %
        imageListe[currentGroupIndex].length;
      return newIndexes;
    });
  };

  const handleNextImage = (currentGroupIndex) => {
    setActiveIndexes((prevIndexes) => {
      const newIndexes = [...prevIndexes];
      newIndexes[currentGroupIndex] =
        (newIndexes[currentGroupIndex] + 1) %
        imageListe[currentGroupIndex].length;
      return newIndexes;
    });
  };
  const apiUrl = `${process.env.REACT_APP_API_URL}`;
  function getImageURL(candidatureId) {
    return `${apiUrl}/realisation/${candidatureId}/image`;
  }
  return (
    <section>
      <div className="program container mt-5">
        {/* Div en haut avec les titres */}
        <div className="top-content-prog">
          <h1 className="big-title-prog">
            Découvrez nos programmes humanitaires en Afrique
          </h1>
        </div>
        {realisations.map((item, index) => (
          <div className="row  " key={item.id}>
            {/* Alterner les colonnes selon `index` */}
            {index % 2 === 0 ? (
              <>
                <div className="col-lg-6 mb-3 ">
                  <div className="card-prog w-100 h-100 d-flex align-items-center justify-content-center">
                    <div className="card-text-prog p-5 mt-4">
                      <div className="card-title-prog ">{item.title}</div>
                      {item.description}
                    </div>
                  </div>
                </div>
                <div className="col-lg-6 mb-3  d-flex h-auto">
                  <div className="card-content-prog w-100 ">
                    {index < 3 ? (
                      <div className="carousel h-auto w-100 ">
                        {/* Carrousel d'images */}
                        <div className="d-flex justify-content-center w-100">
                          <button
                            onClick={() => handlePrevImage(index)}
                            className="btn-prev"
                          >
                            <img
                              src={leftArrow}
                              alt="Précédent"
                              className="arrow-icon"
                            />
                          </button>
                          <div className="carousel-inner w-100 h-auto">
                            {imageListe[index % imageListe.length][
                              activeIndexes[index]
                            ].endsWith(".mp4") ? (
                              <video controls loop className=" w-100 h-video ">
                                <source
                                  src={
                                    imageListe[index % imageListe.length][
                                      activeIndexes[index]
                                    ]
                                  }
                                  type="video/mp4"
                                />
                                Votre navigateur ne supporte pas les vidéos
                                HTML5.
                              </video>
                            ) : (
                              <img
                                src={
                                  imageListe[index % imageListe.length][
                                    activeIndexes[index]
                                  ]
                                }
                                alt={`Illustration ${item.title}`}
                                className="card-image-prog w-100 h-auto"
                              />
                            )}
                          </div>

                          <button
                            onClick={() => handleNextImage(index)}
                            className="btn-next"
                          >
                            <img
                              src={rightArrow}
                              alt="Suivant"
                              className="arrow-icon"
                            />
                          </button>
                        </div>
                      </div>
                    ) : (
                      <img
                        src={getImageURL(item?.id)}
                        alt={`Illustration ${item.title}`}
                        className="card-image-prog w-100 h-100"
                      />
                    )}
                  </div>
                </div>
              </>
            ) : (
              <>
                <div className="col-lg-6 mb-3  d-flex  h-auto">
                  <div className="card-content-prog ">
                    {index < 3 ? (
                      <div className="carousel h-100">
                        {/* Carrousel d'images */}
                        <div className="d-flex justify-content-center h-100">
                          <button
                            onClick={() => handlePrevImage(index)}
                            className="btn-prev"
                          >
                            <img
                              src={leftArrow}
                              alt="Précédent"
                              className="arrow-icon"
                            />
                          </button>
                          <div className="carousel-inner">
                            {imageListe[index % imageListe.length][
                              activeIndexes[index]
                            ].endsWith(".mp4") ? (
                              <video
                                controls
                                loop
                                className="card-image-prog w-100 h-100"
                              >
                                <source
                                  src={
                                    imageListe[index % imageListe.length][
                                      activeIndexes[index]
                                    ]
                                  }
                                  type="video/mp4"
                                />
                                Votre navigateur ne supporte pas les vidéos
                                HTML5.
                              </video>
                            ) : (
                              <img
                                src={
                                  imageListe[index % imageListe.length][
                                    activeIndexes[index]
                                  ]
                                }
                                alt={`Illustration ${item.title}`}
                                className="card-image-prog w-100 h-100"
                              />
                            )}
                          </div>

                          <button
                            onClick={() => handleNextImage(index)}
                            className="btn-next"
                          >
                            <img
                              src={rightArrow}
                              alt="Suivant"
                              className="arrow-icon"
                            />
                          </button>
                        </div>
                      </div>
                    ) : (
                      <img
                        src={getImageURL(item?.id)}
                        alt={`Illustration ${item.title}`}
                        className="card-image-prog w-100 h-100"
                      />
                    )}
                  </div>
                </div>
                <div className="col-lg-6 mb-3 h-100">
                  <div className="card-prog w-100 h-100 d-flex align-items-center">
                    <div className="card-text-prog p-5 mt-4">
                      <div className="card-title-prog  ">{item.title}</div>
                      {item.description}
                    </div>
                  </div>
                </div>
              </>
            )}
          </div>
        ))}
        <div className="col-lg-12 mb-3">
          <div className="card-prog w-100 h-100 d-flex align-items-center justify-content-center">
            <div className="card-text-prog p-5 mt-4">
              <div className="card-title-prog ">
                Développement d’infrastructures locales
              </div>
              Au-delà des forages, la fondation investit dans l’amélioration des
              infrastructures locales, telles que la construction de ponts, de
              routes ou de structures sanitaires. Ces projets permettent aux
              communautés de mieux se connecter aux centres urbains, de
              faciliter l’accès aux soins de santé et d’améliorer la qualité de
              vie générale des habitants.
            </div>
          </div>
        </div>
        <div className="col-lg-12 mb-3">
          <div className="card-prog w-100 h-100 d-flex align-items-center justify-content-center">
            <div className="card-text-prog p-5 mt-4">
              <div className="card-title-prog ">
                Soutien aux communautés durant les crises
              </div>
              Lors de crises humanitaires, telles que les conflits armés ou les
              catastrophes naturelles, la fondation a été présente pour apporter
              un soutien immédiat. Que ce soit par l’envoi de secours d’urgence
              ou la mise en place de centres temporaires d’hébergement, nous
              nous efforçons de répondre rapidement aux besoins des populations
              touchées.{" "}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default Programs;
